import {
    v1 as uuidv1,
    v4 as uuidv4
} from 'uuid';

export function getUId({ version = 1 }){

    if(version === 1) return uuidv1()
    // if(version === 2) return uuid.v2()
    // if(version === 3) return uuid.v3()
    if(version === 4) return uuidv4()
    // if(version === 5) return uuid.v5()

    // return uuidv4();
    return "";
};